<template>
  <el-dialog
    :title="appGuideTitle"
    :visible="showAppGuide"
    width="670px"
    :close-on-click-modal="false"
    :before-close="handleClose"
  >
    <div class="plan-Guide-dialog">
      <el-form ref="guideForm" :model="addGuideForm" :rules="formRules" label-width="120px">
        <el-form-item label="标题名称：" prop="guideName">
          <el-input size="medium" v-model.trim="addGuideForm.guideName" maxlength="20" placeholder="请输入标题名称" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="所属类目：" prop="categoryId">
          <el-select v-model="addGuideForm.categoryId" filterable size="medium" class="selectinput" placeholder="请选择类目" style="width:100%">
            <el-option v-for="item in categoryList" :key="item.id" :label="item.categoryName" :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="封面图片：" prop="coverUrl">
          <div class="upload-cover-img">
            <BaseUploadFile :fileSize="10" :isShowTip="false" :fileType="['png', 'jpg', 'jpeg']" :size="110" :isCompress='true'
              :height="88" :beforeRemove="handleShareRemove" :responseFn="sharePicChange"
              :action="VUE_APP_WECHATBASE_URL" :data="{ path:'dsicm-doctor', type: 'image', mediaId: '' }"
              v-model="addGuideForm.coverUrl"></BaseUploadFile>
            <div>建议646 x 204px，＜10M，png/jpg/jpeg</div>
          </div>
        </el-form-item>

        <el-form-item label="内容：" prop="contentType">
          <el-radio-group v-model="addGuideForm.contentType">
            <el-radio :label="1">富文本</el-radio>
            <el-radio :label="2">PDF</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="addGuideForm.contentType == 1" label="">
          <wangeditorNew :formData="addGuideForm" :index="1000" :isCheck="isCheck" v-if="isCheck" @content="contentChange"  style="width:100%"></wangeditorNew>
        </el-form-item>

        <el-form-item v-if="addGuideForm.contentType == 2" label="">
          <el-upload
            v-if="!pdfName"
            class="avatar-uploader"
            action="/api/dsicm-contact-platform/feign/file/upload"
            :before-upload="beforeAvatarUpload"
            :headers="headers"
            :data="{ path: 'dsicm-guide' }"
            :show-file-list="false"
            :on-success="handleChange"
          >
            <!-- <img v-if="pdfName" :src="checkFormData.imageUrl" class="avatar"> -->
            <el-button size="small" class="add-item" type="primary">
              + 上传PDF</el-button>
          </el-upload>
          <div v-if="pdfName" class="uploaded-pdf">
            <img src="@/assets/images/pdf-icon.png" style="margin-right:18px"/>
            <span style="vertical-align:top" class="pdf-name" :title="pdfName">{{pdfName}}</span>
            <!-- <el-button type="text" style="margin-left:20px" size="small" @click="delPdfName">删除</el-button> -->
            <el-upload
              action="/api/dsicm-contact-platform/feign/file/upload"
              :before-upload="beforeAvatarUpload"
              :headers="headers"
              :data="{ path: 'dsicm-guide' }"
              :show-file-list="false"
              :on-success="handleChange"
            >
              <el-button type="text" style="margin-left:20px" size="small">重新上传</el-button>
            </el-upload>
          </div>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="cancelGuideForm">取 消</el-button>
      <el-button size="small" type="primary" @click="saveGuideForm">保 存</el-button>
    </span>
  </el-dialog>
</template>
<script>
import {pageCategory,guideDetail,addGuide,updateGuide} from "@/api/appOperateCourse"
import local from "@/utils/local.js";
import { DEEP_CLONE } from '@/utils/constants'
import wangeditorNew from '@/components/wangeditorNew/index.vue'
export default {
  props: {
    appGuideTitle: {
      type: String
    },
    showAppGuide: {
      type: Boolean
    },
    selectGuideRow:{
      type: Object,
      default: () => {}
    },
    selectGuideData:{
      type: Array,
      default: () => []
    }
  },
  components: {
    wangeditorNew
  },
  data() {
    return {
      categoryList: [],
      // contentChange: '',
      isCheck: true,
      pdfName: '',
      VUE_APP_WECHATBASE_URL: '/api/dsicm-contact-platform/feign/file/upload',
      headers: {
        Authorization: localStorage.getItem('Authorization'),
      },
      imgPath: process.env.VUE_APP_OSS_URL,
      addGuideForm: {
        guideName: '',
        categoryId: '',
        coverUrl: '',
        contentType: 1,
        contentText: ''
      },
      formRules: {
        guideName: [{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }],
        categoryId: [{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }],
        contentType: [{ required: true, message: '此项为必填项', trigger: ['change', 'blur'] }]
      }
    }
  },
  async created() {
    this.getPageCategory()
    if (JSON.stringify(this.selectGuideRow) !== '{}') {
      this.getGuideDetail()
    }
  },
  mounted() {

  },
  methods: {
    async getGuideDetail() {
      let res = await guideDetail(this.selectGuideRow.id)
      if (res.code === 0) {
        this.addGuideForm = res.data
        this.addGuideForm.content = res.data.contentText
      }
    },
    contentChange(content){
      this.addGuideForm.contentText = content.content
    },
    // 上传封面图
    handleShareRemove() {
      this.addGuideForm.coverUrl = ''
    },
    sharePicChange(response, file, fileList) {
      let url;
      if (response.code == 0) {
        url = this.imgPath + response.data;
      }
      return url;
    },
    // 查询类目list
    async getPageCategory() {
      let res = await pageCategory({
        categoryName: this.categoryName,
        size: 5000,
        current: 1
      })
      if (res.code === 0) {
        this.categoryList = res.data.records
      }
    },
    // 上传pdf校验
    beforeAvatarUpload(file) {
      let suffix =
        file.name.substring(file.name.lastIndexOf(".") + 1) === "pdf";
      if (!suffix) {
        this.$message.error("仅支持上传PDF格式的附件!");
      } else {
        this.pdfName = file.name;
      }
      return suffix;
    },
    // delPdfName() {
    //   this.addGuideForm.contentAnnex = ''
    //   this.pdfName = ''
    // },
    // 上传pdf
    handleChange(file) {
      this.addGuideForm.contentAnnex = process.env.VUE_APP_OSS_URL + file.data;
      this.$message.success("上传成功");
    },
    async saveGuideForm() {
      this.$refs.guideForm.validate(async(val) => {
        if (val) {
          if (!this.addGuideForm.contentAnnex && !this.addGuideForm.content) {
            this.$message.error("请填选内容!");
            return
          }
          if (this.addGuideForm.contentType == 1) {
            this.addGuideForm.contentAnnex = ''
          }
          if (this.addGuideForm.contentType == 2) {
            this.addGuideForm.content = ''
          }

          if (this.selectGuideRow.id) {
            let res = await updateGuide({...this.addGuideForm})
            if (res.code === 0) {
              this.$message.success('保存成功')
              this.$emit('update:showAppGuide', false)
              this.$emit('getPageGuide')
            }
          } else {
            let res = await addGuide({...this.addGuideForm})
            if (res.code === 0) {
              this.$message.success('编辑成功')
              this.$emit('update:showAppGuide', false)
              this.$emit('getPageGuide')
            }
          }
        } else {

        }
      })
    },
    cancelGuideForm() {
      this.$emit('update:showAppGuide', false)
    },
    handleClose() {
      this.$emit('update:showAppGuide', false)
    },
  },
};
</script>
<style lang="less" scoped>
.uploaded-pdf {
  width: 100%;
  height: 68px;
  background: #F7FAFB;
  border-radius: 2px;
  display: flex;
  align-items: center;
  padding: 0 20px;
  img {
    width: 36px;
    height: 44px;
  }
}
.pdf-name {
  display: inline-block;
  width: 306px;
  overflow: hidden; 
  white-space: nowrap; 
  text-overflow: ellipsis;
}
/deep/.el-dialog__body {
  padding: 30px 40px;
}
/deep/.el-dialog__footer {
  text-align: center;
}
.plan-Guide-dialog {
  /deep/.el-input-group__append .el-select {
    width:88px;
  }
  /deep/.el-input-group__append .el-select .el-input, .el-input-group__append .el-select .el-input--suffix {
    width: 88px;
  }
}
/deep/.el-upload {
  width: 100%;
}
.add-item {
  // width: 100%;

  // background-color: #fcfcfc;
  border: 1px dashed #d9d9d9;
  color: #333333;
  // width: 247px;
  // height: 35px;

  width: 100%;
  height: 68px;
  background: #FFFFFF;
  border-radius: 2px;
  // border: 1px solid #D9D9D9;
}
</style>
